var map = {
	"./admin_settings.png": 1821,
	"./appraisals.png": 1822,
	"./catalog.png": 1823,
	"./catalogWhite.png": 1824,
	"./catalog_orders.png": 1825,
	"./cms.png": 1826,
	"./component-fields/Asset.png": 1827,
	"./component-fields/Blocks.png": 1828,
	"./component-fields/Boolean.png": 1829,
	"./component-fields/Date-time.png": 1830,
	"./component-fields/LInk.png": 1831,
	"./component-fields/Markdown.png": 1832,
	"./component-fields/Multi asset.png": 1833,
	"./component-fields/Multi options.png": 1834,
	"./component-fields/Number.png": 1835,
	"./component-fields/Richtext.png": 1836,
	"./component-fields/Single options.png": 1837,
	"./component-fields/Table.png": 1838,
	"./component-fields/Text area.png": 1839,
	"./component-fields/Text.png": 1840,
	"./components.png": 1841,
	"./configuration.png": 1842,
	"./contents.png": 1843,
	"./crm.png": 1844,
	"./custom_order.png": 1845,
	"./customer_credits.png": 1846,
	"./customer_list.png": 1847,
	"./dashboard.png": 1848,
	"./finance.png": 1849,
	"./home.png": 1850,
	"./integrations.png": 1851,
	"./inventory-transfers.png": 1852,
	"./invoice-list.png": 1853,
	"./layaway.png": 1854,
	"./move.png": 1855,
	"./new_sale.png": 1856,
	"./orders.png": 1857,
	"./outgoing-consignments.png": 1858,
	"./payment-methods/amex.png": 1214,
	"./payment-methods/discover.png": 1213,
	"./payment-methods/mastercard.png": 1212,
	"./payment-methods/visa.png": 1211,
	"./payments.png": 1859,
	"./plus.png": 1408,
	"./register.png": 1860,
	"./repair_center.png": 1861,
	"./reports.png": 1862,
	"./services.png": 1863,
	"./trade_in_center.png": 1864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1756;